
import React, { useState, useEffect } from 'react';
import PageTransition from '@/components/layout/PageTransition';
import SecurityConfig from '@/components/security/SecurityConfig';
import SecurityProcess from '@/components/security/SecurityProcess';
import SecurityMapWrapper from '@/components/security/SecurityMapWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { Maximize2, Minimize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMobile } from '@/hooks/use-mobile';

const Security = () => {
  const [mapExpanded, setMapExpanded] = useState(false);
  const isMobile = useMobile();

  const toggleMapExpansion = () => {
    setMapExpanded(!mapExpanded);
  };

  // Force a re-render after component mounts to ensure map initializes properly
  const [refreshKey, setRefreshKey] = useState(0);
  
  useEffect(() => {
    // Small delay to ensure DOM is ready before map initialization
    const timer = setTimeout(() => {
      setRefreshKey(prev => prev + 1);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageTransition>
      <div className={`${mapExpanded ? 'p-0 h-screen' : 'section-padding'}`}>
        {!mapExpanded && (
          <div className="mb-4 md:mb-6">
            <h1 className="text-xl md:text-2xl font-bold">Security Operations</h1>
            <p className="text-muted-foreground text-sm md:text-base">
              Monitor and manage security across your mesh network
            </p>
          </div>
        )}
        
        <div className="grid grid-cols-1 gap-4 md:gap-6">
          {/* Security Map Section with increased height */}
          <Card className={`${mapExpanded ? 'fixed inset-0 z-50 rounded-none border-0 h-screen' : 'relative'}`}>
            <CardContent className={`p-0 overflow-hidden ${mapExpanded ? 'h-full' : 'h-[400px] md:h-[550px]'}`}>
              <Button 
                variant="outline" 
                size="sm" 
                className="absolute top-2 right-2 md:top-3 md:right-3 z-10"
                onClick={toggleMapExpansion}
              >
                {mapExpanded ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
              </Button>
              <div key={refreshKey} className={`${mapExpanded ? 'h-screen w-full' : 'h-full'}`}>
                <SecurityMapWrapper />
              </div>
            </CardContent>
          </Card>
          
          {/* Only show other sections when map is not expanded */}
          {!mapExpanded && (
            <>
              {/* Security Process Section */}
              <div className="mt-4 md:mt-6">
                <SecurityProcess />
              </div>
              
              {/* Security Config Section */}
              <div className="mt-4 md:mt-6">
                <SecurityConfig />
              </div>
            </>
          )}
        </div>
      </div>
    </PageTransition>
  );
};

export default Security;
